import { BankData, BankDataItem } from '@formunauts/banking/domain';
import { CountryBankData } from './country-bank-data';
import { DefaultCountryBankData } from './default-country-bank-data';
import { GbBankData, GbBankDataItem } from './gb.bank-data';

/**
 * @param country The country
 * @param data The data for this country
 *
 * @returns
 * A new instance of `CountryBankData` for the given `country`.
 */
export function CountryBankDataFactory(
  country: 'GB',
  data: BankData<GbBankDataItem>,
): CountryBankData<GbBankDataItem>;
export function CountryBankDataFactory(
  country: string,
  data: BankData<BankDataItem>,
): CountryBankData<BankDataItem>;
export function CountryBankDataFactory<T extends BankDataItem>(
  country: string,
  data: BankData<T>,
): CountryBankData<unknown[]> {
  switch (country) {
    case 'GB':
      return new GbBankData(
        country,
        data as unknown as BankData<GbBankDataItem>,
      );
    default:
      return new DefaultCountryBankData(
        country,
        data as BankData<BankDataItem>,
      );
  }
}
